import { TeamSpot } from '@optools/components/team-spot';
import { Separator } from '@optools/components/ui/separator';
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from '@optools/components/ui/sheet';
import { Region } from '@optools/services/operator-gateway/types/generated/graphql';
import { Team } from '@optools/services/statsapi/types';

import { PipelineInputConfigTable } from './pipeline-input-config-table';

export interface PipelineInputConfigsSheetProps {
  onOpenChange: (open: boolean) => void;
  open: boolean;
  team: Team | null;
}

export function PipelineInputConfigsSheet({
  onOpenChange,
  open,
  team,
}: PipelineInputConfigsSheetProps) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent data-testid="pipeline-config-sheet">
        <SheetHeader>
          <SheetTitle className="flex flex-wrap items-center gap-6">
            <div className="flex items-center gap-2">
              <TeamSpot id={team?.id} showAbbreviation={false} size={32} />
              <span>Team ID: {team?.id}</span>
            </div>
            <span>Venue: {team?.venue.name}</span> <span>Venue ID: {team?.venue.id}</span>{' '}
          </SheetTitle>
          <SheetDescription className="sr-only">Edit the pipeline config</SheetDescription>
          <Separator className="mt-4" />
        </SheetHeader>

        <h2 className="mb-4 text-xl font-bold">Input Configs</h2>
        {Object.values(Region).map((region) => {
          return (
            <PipelineInputConfigTable key={region} region={region} venueId={team?.venue?.id} />
          );
        })}
      </SheetContent>
    </Sheet>
  );
}
